module.exports = __webpack_public_path__ + "static/media/mountains2.f13203c8.svg";